<template>
  <div class="home-content">
    <common-carousel :carouselData="carouselData" />

    <div class="container" style="padding-top: 100px">
      <!-- SaaS产品介绍  stat -->
      <div class="container-header">
        <img
          class="container-leftTitle"
          :src="`${$baseImgUrl}images/leftTitle.png`"
          alt=""
        />

        <span class="container-title">了解我们的SaaS产品</span>
        <img
          class="container-right-title"
          :src="`${$baseImgUrl}images/rightTitle.png`"
          alt=""
        />

        <p class="container-describe">
          全场景全链路的SaaS产品，助力企业数字升级
        </p>
      </div>
      <div class="container-content">
        <el-row :gutter="50">
          <el-col :span="12">
            <el-card class="box-card">
              <div class="box-card-left">
                <img :src="`${$baseImgUrl}images/card.png`" alt="" />
              </div>
              <div class="box-card-right">
                <!-- <h3>数字名片</h3>
                <ul>
                  <li>· 创建名片</li>
                  <li>· 分享名片/文章/图片/短视频</li>
                  <li>· 社群裂变</li>
                  <li>· 雷达跟踪与分析</li>
                </ul> -->
                <h3>开场白</h3>
                <ul>
                  <li>· 定制开场白</li>
                  <li>· 开场白智能回复</li>
                  <li>· 开场白图片分享</li>
                  <li>· 开场白素材分享</li>
                </ul>
              </div>
              <div class="bottom clearfix">
                <span type="text" class="button"
                  >更多<i class="el-icon-right"></i
                ></span>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div class="box-card-left">
                <img :src="`${$baseImgUrl}images/shop.png`" alt="" />
              </div>
              <div class="box-card-right">
                <!-- <h3>门店商城</h3>
                <ul>
                  <li>· 店铺主页/设计师主页</li>
                  <li>
                    <el-row :gutter="20">
                      <el-col :span="12"> · 商品/方案/案例库 </el-col>
                      <el-col :span="12"> · 在线支付下单 </el-col>
                    </el-row>
                  </li>
                  <li>
                    <el-row :gutter="20">
                      <el-col :span="12"> · 在线股价与预约设计 </el-col>
                      <el-col :span="12"> · 会员裂变 </el-col>
                    </el-row>
                  </li>
                </ul> -->
                <h3>图片素材</h3>
                <ul>
                  <li>· 图片素材库</li>
                  <li>
                    <el-row :gutter="20">
                      <el-col :span="12"> · 方案/案例库 </el-col>
                      <el-col :span="12"> · 在线分享 </el-col>
                    </el-row>
                  </li>
                  <li>
                    <el-row :gutter="20">
                      <el-col :span="12"> · 图片库 </el-col>
                      <el-col :span="12"> · 在线分享 </el-col>
                    </el-row>
                  </li>
                </ul>
              </div>
              <div class="bottom clearfix">
                <span type="text" class="button"
                  >更多<i class="el-icon-right"></i
                ></span>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <observer @on-change="upwardOnChange" :threshold="threshold">
          <el-row
            :gutter="50"
            style="padding-top: 50px"
            :class="{ 'visible-content': visibleContent }"
          >
            <el-col :span="12" class="card-col">
              <el-card class="box-card animation-10 animation-upward">
                <div class="box-card-left">
                  <img :src="`${$baseImgUrl}images/number.png`" alt="" />
                </div>
                <div class="box-card-right">
                  <h3>{{webType === 0 ? '派加' : webType === 1 ? '卡百利' : ''}}门店助手</h3>
                  <ul>
                    <li>
                      <el-row :gutter="0">
                        <el-col :span="12"> · 线索管理 </el-col>
                        <el-col :span="12"> · 客户管理 </el-col>
                      </el-row>
                    </li>
                    <li>
                      <el-row :gutter="0">
                        <el-col :span="12"> · 装修日记 </el-col>
                        <el-col :span="12"> · 财务报表 </el-col>
                      </el-row>
                    </li>
                    <li>· 销售OKR</li>
                  </ul>
                </div>
                <div class="bottom clearfix">
                  <span type="text" class="button"
                    >更多<i class="el-icon-right"></i
                  ></span>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12" class="card-col">
              <el-card class="box-card animation-10 animation-upward">
                <div class="box-card-left">
                  <img :src="`${$baseImgUrl}images/design.png`" alt="" />
                </div>
                <div class="box-card-right">
                  <!-- <h3>设计中台</h3>
                  <ul>
                    <li>
                      <el-row :gutter="20">
                        <el-col :span="12"> · 1000+商品库 </el-col>
                        <el-col :span="12"> · 1000+种子方案库 </el-col>
                      </el-row>
                    </li>
                    <li>
                      <el-row :gutter="50">
                        <el-col :span="12"> · 海量案例库</el-col>
                        <el-col :span="12"> · 全国户型图</el-col>
                      </el-row>
                    </li>
                    <li>· 一键报价下单</li>
                  </ul> -->
                  <h3>小卡销售键盘</h3>
                  <ul>
                    <li>
                      <el-row :gutter="20">
                        <el-col :span="12"> · 素材库 </el-col>
                        <el-col :span="12"> · 10+素材案例库 </el-col>
                      </el-row>
                    </li>
                    <li>
                      <el-row :gutter="50">
                        <el-col :span="12"> · 图片库</el-col>
                        <el-col :span="12"> · 产品图片库</el-col>
                      </el-row>
                    </li>
                    <li>· 一键分享</li>
                  </ul>
                </div>
                <div class="bottom clearfix">
                  <span type="text" class="button"
                    >更多<i class="el-icon-right"></i
                  ></span>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <!-- SaaS产品介绍  end -->
        </observer>
      </div>
    </div>

    <!-- 地图 -->
    <div class="container-bottom">
      <observer @on-change="rightOnChange" :threshold="threshold">
        <div
          class="container-bottom-map"
          :class="{ 'visible-bottom': visibleBottom }"
        >
          <img
            :src="`${$baseImgUrl}images/map.png`"
            alt=""
            style="float: right"
          />

          <div style="margin-top: 150px" class="animation-right animation-10">
            <el-card class="container-bottom-card">
              <img
                :src="`${$baseImgUrl}images/province.png`"
                alt=""
                style="float: left; padding-right: 18px"
              />
              <div>
                <p class="container-bottom-num">20+</p>
                <p class="container-bottom-name">省份</p>
              </div>
            </el-card>
            <el-card class="container-bottom-card" style="margin-top: 80px">
              <img
                :src="`${$baseImgUrl}images/dealer.png`"
                alt=""
                style="float: left; padding-right: 18px"
              />
              <div>
                <p class="container-bottom-num">1000+</p>
                <p class="container-bottom-name">经销商</p>
              </div>
            </el-card>
          </div>
        </div>
      </observer>
    </div>
  </div>
</template>
<script>
import commonCarousel from '@/components/common/carousel'
import Observer from '@/components/index.js'

export default {
  components: {
    commonCarousel, Observer
  },

  data () {
    return {
      exposureData: {
        start_time: true
      },
      threshold: [1], // [0, 0.25, 0.5, 0.75, 1] 1：元素百分百滑动到可见区域时
      visibleContent: false, // 显示-向上的动画效果
      visibleBottom: false, // 显示-向左/右动画效果
      isFixed: false,
      goodsAnimationShow: false, // 动画-产品
      mapAnimationShow: false, // 动画-地图

      carouselData: [
        {
          title: '派加Saas化产品',
          subTitle: '主要帮助家居行业的品牌方，提供CRM、数字化营销、商城小程序、企业商学院产品的开发及运营',
          rightImg: `${this.$baseImgUrl}images/home-slideshowRight-1.png`,
          url: `${this.$baseImgUrl}images/home-slideshow-1.png`
        }
      ]

    }
  },
  created() {
    if (this.webType === 0) {
      this.carouselData[0].title = '派加Saas化产品'
      this.carouselData[0].subTitle = '主要帮助家居行业的品牌方，提供CRM、数字化营销、商城小程序、企业商学院产品的开发及运营'
    } else if (this.webType === 1) {
      // this.carouselData[0].title = '卡百利Saas化产品'
      this.carouselData[0].title = '小卡销售键盘'
      this.carouselData[0].subTitle = '小卡销售键盘，专为销售场景打造的实用利器，提供开场白、图片、素材、智能回复应用及运营'
    }
  },
  mounted () {
    // 监听滚动条

  },

  methods: {
    upwardOnChange (entry) {
      // 向上-动画
      if (!this.visibleContent) {
        this.visibleContent = entry.isIntersecting
      }
    },
    rightOnChange (entry) {
      // 左右-动画
      if (!this.visibleBottom) {
        this.visibleBottom = entry.isIntersecting
      }
    }
  }
}
</script>

<style  lang="less" scoped>
@import url("//unpkg.com/element-ui@2.15.1/lib/theme-chalk/index.css");
@headerHeight: 120px;
.home-content {
  margin-top: 70px;
}
.container-header {
  text-align: center;
}
.container-title {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 45px;
}
.container-leftTitle {
  padding-right: 20px;
}
.container-right-title {
  padding-left: 20px;
}
.container-describe {
  padding-top: 13px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.container-content {
  padding-top: 60px;
}
.box-card {
  position: relative;
  height: 240px;
}
.box-card-left {
  position: absolute;
}
.box-card-right {
  margin-left: 200px;
  ul {
    padding-top: 5px;
  }
  li {
    font-size: 14px;
    padding-top: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
}
.button {
  position: absolute;
  bottom: 15px;
  right: 25px;
  color: #4a90e2;
  font-size: 14px;
  i {
    color: #4a90e2;
  }
}

.container-bottom {
  margin-top: 100px;
  background: #f5f8fe;
  height: 970px;
}
.container-bottom-map {
  padding-top: 115px;
  width: 1200px;
  margin: 0 auto;
}
.container-bottom-card {
  height: 120px;
  width: 240px;
}
.container-bottom-num {
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3e3f79;
}
.container-bottom-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a75;
}
// 动画-上
.animation-upward {
  opacity: 0;
  transform: translateY(50px);
  transform: translateY(50px);
  -ms-transform: translateY(50px);
  -moz-transform: translateY(50px);
  -webkit-transform: translateY(50px);
  -o-transform: translateY(50px);
}

.visible-content .animation-upward {
  transform: translateY(0);
  transform: translateY(0);
  -ms-transform: translateY(0);
  -moz-transform: translateY(0);
  -webkit-transform: translateY(0);
  -o-transform: translateY(0);
  opacity: 1;
}
// 动画-右
.animation-right {
  opacity: 0;
  transform: translateX(100px);
  transform: translateX(100px);
  -ms-transform: translateX(100px);
  -moz-transform: translateX(100px);
  -webkit-transform: translateX(100px);
  -o-transform: translateX(100px);
}

.visible-bottom .animation-right {
  transform: translateX(0);
  transform: translateX(0);
  -ms-transform: translateX(0);
  -moz-transform: translateX(0);
  -webkit-transform: translateX(0);
  -o-transform: translateX(0);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue